import React from "react";

const fmtMonto = (val) => {
  try {
    const n = Number(val);
    if (Number.isNaN(n)) return String(val);
    return n.toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } catch { return String(val); }
};

const fmtDate = (val) => {
  if (!val) return "—";
  try {
    const d = new Date(val);
    return d.toLocaleDateString("es-VE", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return String(val); }
};

export default function ModalBillingRules({ message, isOpen, onClose }) {
  if (!isOpen || !message) return null;
  const m = message;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-sirius-night px-6 py-4 flex justify-between items-center" style={{ background: "#1e293b" }}>
          <h3 className="text-white text-lg font-bold">{m.nombre}</h3>
          <button onClick={onClose} className="text-white/70 hover:text-white">
            <i className="fas fa-times text-lg"></i>
          </button>
        </div>
        <div className="p-6 space-y-4 text-sm">
          <div className="flex justify-between border-b pb-2">
            <span className="text-blueGray-500 font-semibold">Volumen umbral (mínimo)</span>
            <span>{m.volumen}</span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="text-blueGray-500 font-semibold">Tipo de regla</span>
            <span>
              {m.regla === "lote" ? (
                <span className="bg-indigo-100 text-indigo-700 py-0.5 px-2 rounded-full text-xs font-semibold">Lote (monto fijo)</span>
              ) : (
                <span className="bg-sky-100 text-sky-700 py-0.5 px-2 rounded-full text-xs font-semibold">Por factura</span>
              )}
            </span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="text-blueGray-500 font-semibold">Monto base</span>
            <span className="font-bold">{fmtMonto(m.monto)} {m.moneda?.codigo || ""}</span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="text-blueGray-500 font-semibold">Moneda</span>
            <span>{m.moneda?.codigo || "—"} — {m.moneda?.nombre || ""}</span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="text-blueGray-500 font-semibold">Estado</span>
            <span>
              {m.estado ? (
                <span className="bg-emerald-100 text-emerald-700 py-0.5 px-2 rounded-full text-xs font-semibold"><i className="fas fa-check-circle mr-1"></i>Activa</span>
              ) : (
                <span className="bg-red-100 text-red-600 py-0.5 px-2 rounded-full text-xs font-semibold"><i className="fas fa-ban mr-1"></i>Inactiva</span>
              )}
            </span>
          </div>
          <div className="flex justify-between text-xs text-blueGray-400">
            <span>Creada</span>
            <span>{fmtDate(m.created_at)}</span>
          </div>
          <div className="flex justify-between text-xs text-blueGray-400">
            <span>Actualizada</span>
            <span>{fmtDate(m.updated_at)}</span>
          </div>
        </div>
        <div className="px-6 py-4 bg-blueGray-50 flex justify-end">
          <button onClick={onClose} className="bg-blueGray-600 hover:bg-blueGray-700 text-white font-semibold py-2 px-5 rounded">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
